import { render } from "./LogItem.vue?vue&type=template&id=71be2d70&scoped=true"
import script from "./LogItem.vue?vue&type=script&lang=js"
export * from "./LogItem.vue?vue&type=script&lang=js"

import "./LogItem.vue?vue&type=style&index=0&id=71be2d70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71be2d70"]])

export default __exports__